/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import {
  GetToolUsageSummaryPayload,
  GetToolUsageSummaryPayload$Outbound,
  GetToolUsageSummaryPayload$outboundSchema,
} from "../components/gettoolusagesummarypayload.js";

export type GetToolUsageTotalsSecurityOption1 = {
  apikeyHeaderGramKey: string;
  projectSlugHeaderGramProject: string;
};

export type GetToolUsageTotalsSecurityOption2 = {
  projectSlugHeaderGramProject: string;
  sessionHeaderGramSession: string;
};

export type GetToolUsageTotalsSecurity = {
  option1?: GetToolUsageTotalsSecurityOption1 | undefined;
  option2?: GetToolUsageTotalsSecurityOption2 | undefined;
};

export type GetToolUsageTotalsRequest = {
  /**
   * API Key header
   */
  gramKey?: string | undefined;
  /**
   * Session header
   */
  gramSession?: string | undefined;
  /**
   * project header
   */
  gramProject?: string | undefined;
  getToolUsageSummaryPayload: GetToolUsageSummaryPayload;
};

/** @internal */
export type GetToolUsageTotalsSecurityOption1$Outbound = {
  "apikey_header_Gram-Key": string;
  "project_slug_header_Gram-Project": string;
};

/** @internal */
export const GetToolUsageTotalsSecurityOption1$outboundSchema: z.ZodMiniType<
  GetToolUsageTotalsSecurityOption1$Outbound,
  GetToolUsageTotalsSecurityOption1
> = z.pipe(
  z.object({
    apikeyHeaderGramKey: z.string(),
    projectSlugHeaderGramProject: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      apikeyHeaderGramKey: "apikey_header_Gram-Key",
      projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
    });
  }),
);

export function getToolUsageTotalsSecurityOption1ToJSON(
  getToolUsageTotalsSecurityOption1: GetToolUsageTotalsSecurityOption1,
): string {
  return JSON.stringify(
    GetToolUsageTotalsSecurityOption1$outboundSchema.parse(
      getToolUsageTotalsSecurityOption1,
    ),
  );
}

/** @internal */
export type GetToolUsageTotalsSecurityOption2$Outbound = {
  "project_slug_header_Gram-Project": string;
  "session_header_Gram-Session": string;
};

/** @internal */
export const GetToolUsageTotalsSecurityOption2$outboundSchema: z.ZodMiniType<
  GetToolUsageTotalsSecurityOption2$Outbound,
  GetToolUsageTotalsSecurityOption2
> = z.pipe(
  z.object({
    projectSlugHeaderGramProject: z.string(),
    sessionHeaderGramSession: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
      sessionHeaderGramSession: "session_header_Gram-Session",
    });
  }),
);

export function getToolUsageTotalsSecurityOption2ToJSON(
  getToolUsageTotalsSecurityOption2: GetToolUsageTotalsSecurityOption2,
): string {
  return JSON.stringify(
    GetToolUsageTotalsSecurityOption2$outboundSchema.parse(
      getToolUsageTotalsSecurityOption2,
    ),
  );
}

/** @internal */
export type GetToolUsageTotalsSecurity$Outbound = {
  Option1?: GetToolUsageTotalsSecurityOption1$Outbound | undefined;
  Option2?: GetToolUsageTotalsSecurityOption2$Outbound | undefined;
};

/** @internal */
export const GetToolUsageTotalsSecurity$outboundSchema: z.ZodMiniType<
  GetToolUsageTotalsSecurity$Outbound,
  GetToolUsageTotalsSecurity
> = z.pipe(
  z.object({
    option1: z.optional(
      z.lazy(() => GetToolUsageTotalsSecurityOption1$outboundSchema),
    ),
    option2: z.optional(
      z.lazy(() => GetToolUsageTotalsSecurityOption2$outboundSchema),
    ),
  }),
  z.transform((v) => {
    return remap$(v, {
      option1: "Option1",
      option2: "Option2",
    });
  }),
);

export function getToolUsageTotalsSecurityToJSON(
  getToolUsageTotalsSecurity: GetToolUsageTotalsSecurity,
): string {
  return JSON.stringify(
    GetToolUsageTotalsSecurity$outboundSchema.parse(getToolUsageTotalsSecurity),
  );
}

/** @internal */
export type GetToolUsageTotalsRequest$Outbound = {
  "Gram-Key"?: string | undefined;
  "Gram-Session"?: string | undefined;
  "Gram-Project"?: string | undefined;
  GetToolUsageSummaryPayload: GetToolUsageSummaryPayload$Outbound;
};

/** @internal */
export const GetToolUsageTotalsRequest$outboundSchema: z.ZodMiniType<
  GetToolUsageTotalsRequest$Outbound,
  GetToolUsageTotalsRequest
> = z.pipe(
  z.object({
    gramKey: z.optional(z.string()),
    gramSession: z.optional(z.string()),
    gramProject: z.optional(z.string()),
    getToolUsageSummaryPayload: GetToolUsageSummaryPayload$outboundSchema,
  }),
  z.transform((v) => {
    return remap$(v, {
      gramKey: "Gram-Key",
      gramSession: "Gram-Session",
      gramProject: "Gram-Project",
      getToolUsageSummaryPayload: "GetToolUsageSummaryPayload",
    });
  }),
);

export function getToolUsageTotalsRequestToJSON(
  getToolUsageTotalsRequest: GetToolUsageTotalsRequest,
): string {
  return JSON.stringify(
    GetToolUsageTotalsRequest$outboundSchema.parse(getToolUsageTotalsRequest),
  );
}
